import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TreeviewComponent} from './treeview.component';
import {ContextMenuModule} from '../context-menu/context-menu.module';
import {NodeModule} from '../node/node.module';

@NgModule({
    imports: [
        CommonModule,
        ContextMenuModule,
        NodeModule
    ],
    declarations: [TreeviewComponent],
    providers: [],
    exports: [TreeviewComponent]
})
export class TreeviewModule {}
